import React from 'react';

const SingleItem = ({ data, handleDelete }) => {
    return (
        <>
            <tr>
                <td data-label="Name">
                    {data?.orderSetId?.name}
                </td>
                <td data-label="Completed">{data?.percentage}%</td>

                <td data-label="Action">
                    <button class="btn btn-sm btn-outline-danger " onClick={() => handleDelete(data?._id)} ><i class="la la-trash"></i> </button>
                </td>
            </tr>
        </>
    );
};

export default SingleItem;